import React from "react";
import { Line } from "react-konva";

const DrawnStraightLines = ({
  shapeProps,
  isSelected,
  onSelect,
  onChange,
  tool,
}) => {
  const sLineRef = React.useRef();

  const onMouseEnter = (event) => {
    if (isSelected) {
      event.target.getStage().container().style.cursor = "move";
    }
    if (!isSelected) {
      event.target.getStage().container().style.cursor = "pointer";
    }
  };

  const onMouseLeave = (event) => {
    event.target.getStage().container().style.cursor = "default";
  };

  return (
    <React.Fragment>
      <Line
        points={shapeProps.points}
        stroke={
          shapeProps.tool === "line" || shapeProps.tool === "dotted"
            ? shapeProps.colour
            : "yellow"
        }
        opacity={
          shapeProps.tool === "line" || shapeProps.tool === "dotted" ? 1 : 0.5
        }
        strokeWidth={
          shapeProps.tool === "line" || shapeProps.tool === "dotted" ? 5 : 40
        }
        hitStrokeWidth={
          shapeProps.tool === "line" || shapeProps.tool === "dotted" ? 20 : 40
        }
        tension={0.5}
        draggable={tool === "none" ? true : false}
        lineCap="square"
        name="selectable"
        globalCompositeOperation="source-over"
        dash={shapeProps.tool === "dotted" ? [33, 20] : []}
        onMouseEnter={onMouseEnter}
        onMouseLeave={onMouseLeave}
        onClick={onSelect}
        onTap={onSelect}
        ref={sLineRef}
        {...shapeProps}
        onDragEnd={(e) => {
          onChange({
            ...shapeProps,
            x: e.currentTarget.x(),
            y: e.currentTarget.y(),
          });
        }}
        onTransformEnd={(event) => {
          // transformer is changing scale of the node
          // and NOT its width or height
          // but in the store we have only width and height
          // to match the data better we will reset scale on transform end
          const node = sLineRef.current;
          const scaleX = node.scaleX();
          const scaleY = node.scaleY();

          // we will reset it back
          node.scaleX(1);
          node.scaleY(1);
          onChange({
            ...shapeProps,
            x: node.x(),
            y: node.y(),
            rotation: node.attrs.rotation,
            // set minimal value
            width: Math.max(5, node.width() * scaleX),
            height: Math.max(node.height() * scaleY),
          });
        }}
      />
    </React.Fragment>
  );
};

export default DrawnStraightLines;
